import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../../services/api'
import { SL_ClipLoader } from '../../../components/loading/ClipLoader'
import { Form, Switch, ColorPicker, Space } from 'antd'
import { SL_Input } from '../../../components/input/Input'
import { displayMessage } from '../../../helpers/messages'
import EActivationStatus from '../../../enums/EActivationStatus'
import { SL_Button } from '../../../components/buttons/Button'
import styles from '../../../services/styles'

export function PriorityLevelsDetails({}) {
    const { priorityLevelId } = useParams()

    const navigate = useNavigate()

    const formRef = useRef()

    const [priorityLevel, setPriorityLevel] = useState(null)
    const [loading, setLoading] = useState(false)

    const [isEditing, setIsEditing] = useState(false)

    const [isActive, setIsActive] = useState(null)
    const [color, setColor] = useState(null)

    useEffect(() => {
        loadFrequency()
    }, [])

    const loadFrequency = async () => {
        setLoading(true)
        try {
            const { data } = await api.priorityLevels.find(priorityLevelId)

            setPriorityLevel(data)
            setIsActive(data.is_active)
            setColor(data.color)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const onSubmit = async e => {
        setLoading(true)
        try {
            const auxPriorityLevel = { ...e, is_active: isActive, color }
            await api.priorityLevels.update(priorityLevelId, auxPriorityLevel)
            navigate('/probability-x-gravity')
        } catch (error) {
            console.log(error)
        } finally {
            setIsEditing(false)
            setLoading(false)
        }
    }

    const handleOnChangeColor = value => {
        setColor(value.toHexString())
    }

    return (
        <>
            <div>
                {loading ? (
                    <div className="h-screen w-full fixed top-0 left-0 flex justify-center items-center z-[9998] bg-sl-gray-500 bg-opacity-10">
                        <SL_ClipLoader loading={true} />
                    </div>
                ) : (
                    <>
                        <div className="w-full flex flex-row justify-end">
                            <div className="mr-2">{displayMessage('ENABLE_EDIT')}</div>
                            <Switch onChange={e => setIsEditing(e)} />
                        </div>
                        <div className="w-full flex justify-center">
                            <Form onFinish={onSubmit} className="max-w-[700px] w-full" layout="vertical" requiredMark={false} ref={formRef}>
                                <div className="flex flex-col gap-1">
                                    <div className="">{displayMessage('FIRST_NAME')}</div>

                                    <Form.Item
                                        name="name"
                                        initialValue={priorityLevel?.name}
                                        rules={[{ required: true, message: displayMessage('DISPLAY_NAME') }]}
                                        className="mb-4"
                                    >
                                        <SL_Input placeholder={displayMessage('FIRST_NAME')} className={'w-full text-gray-400'} disabled={true} />
                                    </Form.Item>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <div className="">{displayMessage('MODULE_DESCRIPTION')}</div>

                                    <Form.Item
                                        name="description"
                                        initialValue={priorityLevel?.description}
                                        rules={[{ required: true, message: displayMessage('DISPLAY_DESCRIPTION') }]}
                                        className="mb-4"
                                    >
                                        <SL_Input
                                            placeholder={displayMessage('MODULE_DESCRIPTION')}
                                            className={'w-full text-gray-400'}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <div className="">{displayMessage('BOTTOM_RANGE')}</div>

                                    <Form.Item name="bottom_range" initialValue={priorityLevel?.bottom_range} className="mb-4">
                                        <SL_Input
                                            placeholder={displayMessage('BOTTOM_RANGE')}
                                            className={isEditing ? 'w-full' : 'w-full text-gray-400'}
                                            disabled={!isEditing}
                                        />
                                    </Form.Item>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <div className="">{displayMessage('TOP_RANGE')}</div>

                                    <Form.Item name="top_range" initialValue={priorityLevel?.top_range} className="mb-4">
                                        <SL_Input
                                            placeholder={displayMessage('TOP_RANGE')}
                                            className={isEditing ? 'w-full' : 'w-full text-gray-400'}
                                            disabled={!isEditing}
                                        />
                                    </Form.Item>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <div className="">{displayMessage('COLOR')}</div>

                                    <Form.Item name="color" initialValue={color} className="mb-4">
                                        <Space direction="vertical">
                                            <ColorPicker disabled={!isEditing} defaultValue={color} onChange={handleOnChangeColor} />
                                        </Space>
                                    </Form.Item>
                                </div>

                                {/* <div className="flex flex-col gap-1 mt-1">
                                    <div className="">
                                        {displayMessage('ACTIVATION_STATUS')}
                                    </div>
                                    <SL_Input
                                        placeholder={isActive ? EActivationStatus.ATIVO.description : EActivationStatus.INATIVO.description}
                                        className={'w-full'}
                                        disabled={true}
                                    />
                                </div>

                                <div className="flex flex-col gap-1 mt-5 mb-5">
                                    <SL_Button
                                        className="md-mx-0 rounder-l-none"
                                        style={{
                                            backgroundColor: !isEditing ? 'gray' : isActive ? styles.colors["sl-red"]["400"] : '#0e730d',
                                            color: 'white'
                                        }}
                                        disabled={!isEditing}
                                        onClick={() => setIsActive(prev => !prev)}
                                    >
                                        {isActive ? 'Desativar' : 'Ativar'}
                                    </SL_Button>
                                </div> */}

                                <Form.Item hasFeedback className="mb-3 mt-2">
                                    <SL_Button disabled={!isEditing} type="primary" className={'w-full font-bold shadow-md'} htmlType="submit">
                                        {displayMessage('EDIT')}
                                    </SL_Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </>
                )}
            </div>
        </>
    )
}
